
import { baseUrl } from "../../constants";

export default {
    "formTitle": "Add Ship Type",
    "tableTitle": "Ship Type List",
    "apiDetails": {
        startUp: () => {
        },
        list: {
            url: `${baseUrl}/api/ship/shiptype/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC"
            }
        },
        add: `${baseUrl}/api/ship/shiptype`,
        edit: `${baseUrl}/api/ship/shiptype/edit`,
        delete: `${baseUrl}/api/ship/shiptype/remove`
    },
    "tableCol": [
        {
            name: 'Ship Type',
            selector: row => row.shipType,
            sortable: true
        },
        {
            name: 'Description',
            selector: row => row.description,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Ship Type',
                    name: 'shipType',
                    required: true
                }
            ]
        },
        {
            formType: 'flex',
            formFields: [
                {
                    type: 'textArea',
                    label: 'Description',
                    name: 'description'
                }
            ]
        },
        {
            formType: 'flex',
            formFields: [
                {
                    type: 'file',
                    label: 'Ship Type Picture',
                    name: 'shipTypePic'
                }
            ]
        }
    ],
    "mockData": [{
        "shipType": "sfs",
        "description": "dgdg",
        "shipTypePic": ""
    }]
}